import React from 'react'
interface ValidTickProps {
    color?: string
    width?: string
    height?: string
}
const ValidTick: React.FC<ValidTickProps> = ({ color, width, height }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width || '20'}
        height={height || '20'}
        fill='none'
        viewBox='0 0 20 20'
    >
        <rect width='20' height='20' fill={color || '#00B28A'} rx='10'></rect>
        <path
            fill='#fff'
            d='M8.497 13.611L5 10.056l.874-.889 2.623 2.667 5.629-5.723.874.89-6.503 6.61z'
        ></path>
    </svg>
)

export default ValidTick
